import React from 'react'

export default function TickCircleGreen(props) {
    return (
        <svg {...props} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect width='20' height='20' rx='10' fill='#D4F3EC' />
            <path
                d='M14 7L8.5 12.5L6 10'
                stroke='#319B90'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
